import { useDepartmentText } from 'model/DepartmentTerminology';
import { Box, Group, useMantineTheme } from '@mantine/core';
import { IconBuildingSkyscraper, IconCircleMinus, IconMapPinPlus, IconWorld, IconX } from '@tabler/icons-react';
import P2Medium from 'components/typography/P2Medium';

interface ProvenanceLabelProps {
  provenance: 'global' | 'organization' | 'department';
  globalLabel?: string;
  organizationLabel?: string;
  organizationExcluded?: boolean;
  departmentLabel?: string;
  unknownLabel?: string;
}

/**
 * Returns the label displaying the provenance, based on the parameter.
 */
export default function ProvenanceLabel({
  provenance,
  globalLabel = 'Globálne',
  organizationLabel = 'Vymedzené pre organizácie:',
  organizationExcluded = false,
  departmentLabel,
  unknownLabel = 'Neznáme',
}: ProvenanceLabelProps) {
  const departmentText = useDepartmentText();
  const theme = useMantineTheme();

  if (provenance === 'global') {
    return (
      <Group spacing={8}>
        <IconWorld stroke={1.5} color={theme.colors.red[9]} size={20} />
        <P2Medium color="red.9">{globalLabel}</P2Medium>
      </Group>
    );
  }

  if (provenance === 'organization') {
    return (
      <Group spacing={8}>
        <Box pos="relative" w={20} h={20} style={{ flexShrink: 0 }} aria-hidden="true">
          <IconBuildingSkyscraper stroke={1.5} color={theme.colors.gray[9]} size={20} />
          {organizationExcluded && (
            <IconCircleMinus
              stroke={1.5}
              color={theme.colors.red[9]}
              fill={theme.white}
              size={12}
              style={{ position: 'absolute', right: -3, bottom: -2 }}
            />
          )}
        </Box>
        <P2Medium color="gray.9">{organizationLabel}</P2Medium>
      </Group>
    );
  }

  if (provenance === 'department') {
    return (
      <Group spacing={8}>
        <IconMapPinPlus stroke={1.5} color={theme.colors.gray[9]} size={20} />
        <P2Medium color="gray.9">
          {departmentLabel ?? departmentText('Vymedzené pre položky úrovne:', 'Vymedzené pre strediská:')}
        </P2Medium>
      </Group>
    );
  }

  return (
    <Group spacing={8}>
      <IconX stroke={1.5} color={theme.colors.red[9]} size={20} />
      <P2Medium color="red.9">{unknownLabel}</P2Medium>
    </Group>
  );
}
